import axios from "axios";
class ApiAppVersions {
    static async GetAllAppVersions(session_uuid) {
        try {
            const result = await axios.get((process.env.VUE_APP_API_PATH || "/") + "api/admin/app-version-update", {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data;
        }
        catch (e) {
            throw new Error("Error get users");
        }
    }
    static async GetAppVersionByUUID(session_uuid, app_version_uuid) {
        try {
            const result = await axios.get((process.env.VUE_APP_API_PATH || "/") + `api/admin/app-version-update/${app_version_uuid}`, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data;
        }
        catch (e) {
            console.error(e);
            return undefined;
        }
    }
    static async CreateAppVersionUpdate(session_uuid, version, platform, isMandatory, confirmationRequired, releaseNotes, updateUrl, releasedAt) {
        try {
            const result = await axios.post((process.env.VUE_APP_API_PATH || "/") + "api/admin/app-version-update", {
                version: version,
                platform: platform,
                is_mandatory: isMandatory,
                confirmation_required: confirmationRequired,
                release_notes: releaseNotes,
                update_url: updateUrl,
                released_at: releasedAt
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data;
        }
        catch (e) {
            throw new Error("Failed to create app version");
        }
    }
    static async UpdateAppVersionUpdate(session_uuid, uuid, version, platform, isMandatory, confirmationRequired, releaseNotes, updateUrl, released_at) {
        try {
            const result = await axios.put((process.env.VUE_APP_API_PATH || "/") + `api/admin/app-version-update/${uuid}`, {
                version: version,
                platform: platform,
                is_mandatory: isMandatory,
                confirmation_required: confirmationRequired,
                release_notes: releaseNotes,
                update_url: updateUrl,
                released_at: released_at
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data;
        }
        catch (e) {
            throw new Error("Failed to update app version");
        }
    }
    static async DeleteAppVersionUpdate(session_uuid, app_version_uuid) {
        try {
            const result = await axios.delete((process.env.VUE_APP_API_PATH || "/") + `api/admin/app-version-update/${app_version_uuid}`, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data;
        }
        catch (e) {
            console.error(e);
            return undefined;
        }
    }
    static async GetAppConfirmationHistory(session_uuid, app_version_uuid) {
        try {
            const result = await axios.get((process.env.VUE_APP_API_PATH || "/") + `api/admin/app-version-update/${app_version_uuid}/confirmation-history`, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data;
        }
        catch (e) {
            console.error(e);
            return [];
        }
    }
}
export default ApiAppVersions;
